export default "__VITE_ASSET__DBd205pU__"